import { Box, styled } from '@mui/material';

import { flexMixin } from 'utils/flexMixin';

export const ChangeEmailBox = styled(Box)({
	...flexMixin({ justify: 'space-between', align: 'flex-end' }),

	'& > div': {
		maxWidth: '275px',
	},

	'& button': {
		width: '275px',
		padding: '10px 16px',
		borderRadius: '8px',
		border: '1px solid #4786FF',
		fontSize: '16px',
		fontWeight: '700',
		lineHeight: '157%',
		letterSpacing: '0.1px',
		textTransform: 'none',
		color: '#4786FF',
		boxSizing: 'border-box',

		'&.Mui-disabled': {
			border: '1px solid rgba(0, 0, 0, 0.26)',
		},
	},
});
